'use strict';

var THEME_ID = '$$material';

module.exports = THEME_ID;
//# sourceMappingURL=identifier.cjs.map
